"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unify = void 0;
const indent_1 = require("../../utils/indent");
const Errors = __importStar(require("../errors"));
const solution_1 = require("../solution");
const unify_1 = require("../unify");
const value_1 = require("../value");
/**

   # unify

   `unify` will be used during elaboration (`check` and `infer`),
   to support features like `PiImplicit`.

   The recursion structure of `unify` closely follows `readback`,
   but dealing with two values in each step.

**/
function unify(mod, ctx, type, left, right) {
    type = (0, solution_1.solutionAdvanceValue)(mod, type);
    left = (0, solution_1.solutionAdvanceValue)(mod, left);
    right = (0, solution_1.solutionAdvanceValue)(mod, right);
    try {
        if ((0, unify_1.unifyPatternVar)(mod, ctx, type, left, right))
            return;
        if ((0, unify_1.unifyByType)(mod, ctx, type, left, right))
            return;
        (0, unify_1.unifyByValue)(mod, ctx, type, left, right);
    }
    catch (error) {
        if (error instanceof Errors.UnificationError) {
            error.trace.unshift([
                `[unify]`,
                (0, indent_1.indent)(`type: ${(0, value_1.formatType)(mod, ctx, type)}`),
                (0, indent_1.indent)(`left: ${(0, value_1.formatValue)(mod, ctx, type, left)}`),
                (0, indent_1.indent)(`right: ${(0, value_1.formatValue)(mod, ctx, type, right)}`),
            ].join("\n"));
        }
        if (error instanceof Errors.EvaluationError) {
            throw new Errors.UnificationError([
                `[unify] EvaluationError during unification`,
                error.message,
                (0, indent_1.indent)(`type: ${(0, value_1.formatType)(mod, ctx, type)}`),
                (0, indent_1.indent)(`left: ${(0, value_1.formatValue)(mod, ctx, type, left)}`),
                (0, indent_1.indent)(`right: ${(0, value_1.formatValue)(mod, ctx, type, right)}`),
            ].join("\n"));
        }
        throw error;
    }
}
exports.unify = unify;
//# sourceMappingURL=unify.js.map